import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import {
    AiOutlineBarcode,
    AiOutlineInbox,
    AiOutlineUser,
    AiOutlineWallet,
    AiOutlineGift
  } from "react-icons/ai";

class menu extends Component {
    render() { 
        return (
            <div className="wp-menu">
                <div className="wp-item">
                    <NavLink className="wp-link" to="/home">
                        <AiOutlineBarcode className="wp-link-icon" />
                        <p>بارکدخوان</p>
                    </NavLink>
                </div>
                <div className="wp-item">
                    <NavLink className="wp-link" to="/dina-code">
                        <AiOutlineGift className="wp-link-icon" />
                        <p>دینا کد</p>
                    </NavLink>
                </div>
                <div className="wp-item">
                    <NavLink className="wp-link" to="/transaction">
                        <AiOutlineInbox className="wp-link-icon" />
                        <p>تراکنش‌ها</p>
                    </NavLink>
                </div>
                <div className="wp-item">
                    <NavLink className="wp-link" to="/settlement">
                        <AiOutlineWallet className="wp-link-icon" />
                        <p>برداشت‌ها</p>
                    </NavLink>
                </div>
                <div className="wp-item">
                    <NavLink className="wp-link" to="/profile">
                        <AiOutlineUser className="wp-link-icon" />
                        <p>پروفایل</p>
                    </NavLink>
                </div>
            </div>
        );
    }
}
 
export default menu;